import { render, staticRenderFns } from "./ExportAddPagesTab.vue?vue&type=template&id=104920e9"
import script from "./ExportAddPagesTab.vue?vue&type=script&lang=js"
export * from "./ExportAddPagesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports